import React from "react";
import { PageFooterHyperlink } from "./page-footer-hyperlink";

export const PageFooter = () => {
  return (
    <footer className="page-footer">
      <div className="page-footer-grid">
        <PageFooterHyperlink path="https://auth0.com/">
          <span>Footer</span>
        </PageFooterHyperlink>
      </div>
    </footer>
  );
};
